import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const store = {
  namespaced: true,
  state: {
    timeout: 5000,
    messages: []
  },
  mutations,
  actions,
  getters
};

export default store;
